import React, { Component } from "react";

export class NewsItems extends Component {
  render() {
    const {
      title,
      description,
      imageUrl,
      newsUrl,
      author,
      source,
      publishedAt,
    } = this.props;

    const finalImage =
      imageUrl && imageUrl !== ""
        ? imageUrl.replace("http://", "https://")
        : "https://via.placeholder.com/600x350?text=No+Image";

    const gmtTime = publishedAt
      ? new Date(publishedAt).toUTCString()
      : "Time not available";

    return (
      <div className="card bg-dark text-light h-100 my-3 position-relative">
        
        {/* 🔴 SOURCE BADGE */}
        <span
          className="badge bg-danger position-absolute"
          style={{
            top: "10px",
            right: "10px",
            zIndex: 1,
          }}
        >
          {source || "Unknown"}
        </span>

        <img
          src={finalImage}
          referrerPolicy="no-referrer"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src =
              "https://via.placeholder.com/600x350?text=No+Image";
          }}
          className="card-img-top"
          alt={title || "News image"}
          style={{
            height: "250px",
            objectFit: "cover",
          }}
        />

        <div className="card-body d-flex flex-column">
          <h5 className="card-title">
            {title || "No title available"}
          </h5>

          <p className="card-text">
            {description || "No description available"}
          </p>

          <p className="card-text mt-auto">
            <small className="text-muted">
              By {author || "Unknown"} <br />
              🕒 {gmtTime} (GMT)
            </small>
          </p>

          <a
            href={newsUrl}
            target="_blank"
            rel="noreferrer"
            className="btn btn-sm btn-outline-light mt-2"
          >
            Read More
          </a>
        </div>
      </div>
    );
  }
}

export default NewsItems;
